



















import Vue from "vue";
import dialog from "@/common/mixins/dialog";
import { required } from "vuelidate/lib/validators";
export default Vue.extend({
  mixins: [dialog],
  validations: {
    mcNumber: { required }
  },
  data() {
    const mcNumber = "";
    return {
      mcNumber
    };
  },
  methods: {
    async updateMcStatus() {
      try {
        const {
          data
        } = await (this as any).$dep.orderUseCase.updateOderMcStatus(
          this.mcNumber
        );
        (this as any).alertSuccess("Success", "Update Mc Status to 5 สำเร็จ");
        this.mcNumber = "";
      } catch (error) {
        if (error.response.data.message) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to update Mc Status to 5",
        "คุณต้องการอัพเดท  Mc Status to 5 หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.updateMcStatus();
      }
    }
  }
});
